import $ from 'jquery';

import createOption from './createOption';
import getBRNHCD from '../fetch/getBRNHCD';

const setBrnhcdSelectBoxOptions = async (dlrcd) => {
	const { BRNHCDLIST } = await getBRNHCD(`JsonStr={
		FRAN: "${$('#prglist-selectbox').attr('data-fran')}",
		DLRCD: "${dlrcd}",
		BRNHKIND: "${$('#prglist-selectbox').attr('data-branch-kind')}",
	}`);

	$('#api-BRNHCD').find('option').remove();

	if (BRNHCDLIST.length) {
		$('#password-login-button').removeClass('-disable');
		BRNHCDLIST.forEach(({ BRNHNM, BRNHCD }) => {
			$('#api-BRNHCD').append(createOption(BRNHNM, BRNHCD));
		});
	}
};

export default setBrnhcdSelectBoxOptions;



// WEBPACK FOOTER //
// ./src/js/index/setBrnhcdSelectBoxOptions.js